<template>
  <div id="footer">
    <div class="icontainer">
      <div class="col-md-12 call-us-mg">
        <div v-if="company_phone_help_customer == 1">
          <div v-if="((company_phone1 != '') && (company_mobile1 != ''))" class="col-md-6 col-xs-12 call_us_container">
            <div class="col-md-12 call_us_btn">
              <h4 class="text-center contact-title">
                <a :href="`tel:${country_key}${company_phone1}`">
                <i class="fa fa-phone"></i>
                </a>
                <a class="octopus-phone-number" v-if="company_phone1 != null" :href="`tel:${company_phone1}`" :data-countrycode="`${country_code}`"> {{company_phone1}} </a>
                <a class="octopus-phone-number" v-else-if="(company_phone1 == null) && (company_mobile1 != null)" :href="`tel:${company_phone1}`" :data-countrycode="`${country_code}`">{{company_mobile1}}</a>
              </h4>
              <h5 class="text-center">{{help_customer_available_hours}}</h5>
            </div>
          </div>
        </div>
        <div v-if="brandedApp.is_hidden == 0" class="buttons buttons-position buttons-mg col-md-6">
        <div v-if="brandedApp.ios_link != ''" class="apple_store col-md-4 col-xs-3" style="padding-right:2px !important"><a :href="brandedApp.ios_link" target="_blank"><img  src="/img/app_store.png"/></a></div>
        <div v-if="brandedApp.android_link != ''" class="google_play col-md-4 col-xs-3" style="padding-left:2px !important"><a :href="brandedApp.android_link" target="_blank"><img src="/img/google_play.png"/></a></div>
      </div>
      </div>
      <!-- contains mobile apps icons -->

      <div class="col-md-12 bottom-footer">
        <div class="col-md-6 social">
          <div id="social_networks" style="width:100%; " >
            <ul class="text-center">
              <li  v-for="network in socialNetworks" class="float:none;display:inline"><a :href="network.url" target="_blank" data-toggle="tooltip" :title="network['title']">
                <i v-if="network.url === 'google'" class="fa fa-google-plus"></i>
                <i v-else :class="fa_network + network.title.toLowerCase()"></i>
              </a>
              </li>
            </ul>
          </div>
        </div>
        <!--social-->
        <div class="col-md-6 copy terms_and_conditions_position">
          <p>
            <span v-if="((termsAndConditions != null) && (privacyPolicy != null))"> &nbsp </span>
            <!-- privacy policy link -->
            <a v-if="privacyPolicy != null" :href="privacy_policy_link" target="_blank">{{ privacy_and_policy_translate }}</a>
            <a v-if="termsAndConditions != null" :href="terms_conditions_link" target="_blank">{{terms_and_conditions_translate}}</a>
            <!-- copyrights -->
            &nbsp; &copy; {{ company_name }} </p></div>
      </div>
      <!-- contains copyrights and footer links -->
    </div>
  </div>
</template>


<script>

import {getFooter} from "@/modules/CustomerPortal/api/footer";
export default {
  name: "CustomerPortalFooter",
  props: [
      "company_id",
      "privacy_policy_link",
      "terms_conditions_link",
  ],
  data() {
    return {
      company_name : '',
      country_code : '',
      websiteSettings : '',
      brandedApp : '',
      socialNetworks : '',
      privacyPolicy : '',
      termsAndConditions : '',
      company_phone1 : '',
      company_mobile1 : '',
      company_phone_help_customer : 0,
      help_customer_available_hours : '',
      // call_us_translate : '',
      privacy_and_policy_translate : '',
      terms_and_conditions_translate : '',
      fa_network : 'fa fa-',
      country_key:'',
    }
  },
  methods:{

  },
  computed: {

  },
  mounted() {
      getFooter(this.company_id).then((response) => {
        console.log('id',this.company_id)
        if (response.status == 200) {
          if (response.data.type == 'success') {
            this.company_name = response.data.company_name;
            this.country_code = response.data.country_code;
            this.websiteSettings = response.data.websiteSettings;
            this.brandedApp = response.data.brandedApp;
            this.socialNetworks = response.data.socialNetworks;
            this.privacyPolicy = response.data.privacyPolicy;
            this.termsAndConditions = response.data.termsAndConditions;
            this.company_phone1 = response.data.company_phone1;
            this.company_mobile1 = response.data.company_mobile1;
            this.company_phone_help_customer = response.data.company_phone_help_customer;
            this.help_customer_available_hours = response.data.help_customer_available_hours;
            // this.call_us_translate = response.data.call_us_translate;
            this.privacy_and_policy_translate = response.data.privacy_and_policy_translate;
            this.terms_and_conditions_translate = response.data.terms_and_conditions_translate;
            this.country_key = response.data.country_key;
          }
        }
      })
  }
}
</script>

<style>
.call_us_container {
  margin: auto;
  padding: 10px;
}
.octopus-phone-number{
  color: inherit;
}
</style>